import type { SchoolTestApi } from '@mathflat/domain/@entities/(Content)/SchoolTest/api'
import type { CurriculumApi } from '@mathflat/domain/@entities/Curriculum/api'

import type { DefaultResponse } from '@/types/common'
import maxios from '@/utils/axios/maxios'

// 단원-유형 API
const curriculumApi = {
  getCurriculum: (params: { idSet: number[]; type: 'LITTLE_CHAPTER' | 'CONCEPT' }) => {
    return maxios.get<CurriculumApi.Response.CurriculumInfo[]>(`/curriculums`, {
      params: { ...params },
    })
  },

  getCurriculumTreeByTrieKey: (trieKey: string) => {
    return maxios.get<CurriculumApi.Response.CurriculumTreeFilteByConceptAndChapter[]>(
      `/curriculums/by-key`,
      {
        params: { key: trieKey },
      },
    )
  },
  getCurriculumTreeGroups: (depth = 1) => {
    return maxios.get<DefaultResponse<res.Curriculum[]>>(`/curriculums/tree/group/${depth}`)
  },

  getTopicAndSubTopic: (conceptId: number) => {
    return maxios.get<CurriculumApi.Response.Topic[]>(`/concepts/${conceptId}/sub-topics`)
  },
  getCurriculumCore: () => {
    return maxios.get<CurriculumApi.Response.CurriculumCore>(`/curriculums/core`)
  },
  getCurriculumsBySchoolTestIds: async (params: SchoolTestApi.Request.SchoolTestGroupBySchool) => {
    return maxios.get<CurriculumApi.Response.CurriculumTreeFilter[]>('curriculums/by-school-test', {
      params,
    })
  },
}

export default curriculumApi
